import Loading from "components/Loading";
import useInfiniteScroll from "hooks/useInfiniteScroll";
import { useRef, useState } from "react";
import { useGetAppointmentsQuery } from "store/services/scheduler";
import styles from "./PreviousSessions.module.scss";
import SessionItem from "./SessionItem";

interface PreviousSessionsProps {
  patientId: string;
}

const PreviousSessions = ({ patientId }: PreviousSessionsProps) => {
  const infiniteScrollContainerRef = useRef<HTMLDivElement>(null);

  const [page, setPage] = useState(0);
  const [expandedSessionIndex, setExpandedSessionIndex] = useState(-1);

  const { data, error, isFetching } = useGetAppointmentsQuery({
    page,
    useInfiniteScroll: true,
    hideFutureAppointments: true,
    patientUserId: patientId,
    appointmentIsCancelledOrAbandoned: false,
  });

  useInfiniteScroll({
    containerRef: infiniteScrollContainerRef,
    page,
    setPage,
    currentCount: data?.appointments?.length ?? 0,
    totalCount: data?.total_count ?? 0,
    isFetching,
  });

  const finishedAppointments =
    data?.appointments?.filter(
      (appointment) => appointment.appointment_end < new Date().toISOString(),
    ) ?? [];

  const isEmpty = !isFetching && finishedAppointments.length === 0;

  return (
    <div ref={infiniteScrollContainerRef} className={styles["content"]}>
      {error && <div>Error: {error}</div>}
      {isEmpty && (
        <div className={styles.empty}>
          There are no previous sessions available.
        </div>
      )}
      {finishedAppointments.map((appointment, i) => (
        <SessionItem
          key={appointment.appointment_id}
          appointment={appointment}
          isExpanded={expandedSessionIndex === i}
          onClick={() =>
            setExpandedSessionIndex((previous) => (previous === i ? -1 : i))
          }
        />
      ))}
      {isFetching && <Loading className={styles.loading} />}
    </div>
  );
};

export default PreviousSessions;
